// extracted by mini-css-extract-plugin
export var downloadModalContainer = "styles-module__downloadModalContainer___t8XsS";
export var modalSubText = "styles-module__modalSubText___myxKz";
export var dropdownContainer = "styles-module__dropdownContainer___pdeqa";
export var fullWidth = "styles-module__fullWidth___TtNV3";
export var medium = "styles-module__medium___oIY2t";